import { isDev } from '@/utils/common';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Report: AppRouteRecordRaw = {
  path: '/report',
  name: 'Report',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '报表分析',
    requiresAuth: true,
    icon: 'icon-bar-chart',
    order: 6,
  },
  children: [
    {
      path: 'allprocess-detail-report',
      name: 'AllprocessDetailReport',
      component: () =>
        import('@/views/report/allprocessDetailReport/index.vue'),
      meta: {
        title: '生产明细',
        requiresAuth: true,
        roles: ['completeFlowReportGet'],
      },
    },
    {
      path: 'production-reprot',
      name: 'ProductionReport',
      component: () => import('@/views/report/production/index.vue'),
      meta: {
        title: '生产报表',
        requiresAuth: true,
        roles: ['produceStatisticsGet'],
      },
    },
    {
      path: 'out-days-reprot',
      name: 'OutDaysReport',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '出货分析报表',
        requiresAuth: true,
        roles: ['produceOutStatisticsGet'],
        amisAppId: isDev() ? '21352737' : '05fd89e3',
      },
    },
    {
      path: 'production-monitoring-screen',
      name: 'ProductionMonitoringScreen',
      component: () =>
        import('@/views/production/productionMonitoringScreen/index.vue'),
      meta: {
        title: '生产监控大屏',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'material-transfer-report',
      name: 'MaterialTransferReport',
      component: () =>
        import('@/views/material/materialTransferReport/index.vue'),
      meta: {
        title: '物料调拨报表',
        requiresAuth: true,
        roles: ['materialTransferStatisticsGet'],
      },
    },
    {
      path: 'purchase-report',
      name: 'PurchaseReport',
      component: () => import('@/views/production/purchaseReport/index.vue'),
      meta: {
        title: '生产采购报表',
        requiresAuth: true,
        roles: ['purchaseProcessStatistics', 'purchaseProcessStatisticsGet'],
      },
    },
    {
      path: 'material-purchase-report',
      name: 'MaterialPurchaseReport',
      component: () =>
        import('@/views/report/materialPurchaseReport/index.vue'),
      meta: {
        title: '物料采购报表',
        requiresAuth: true,
        roles: ['materialPurchaseStatisticsGet'],
      },
    },
    {
      path: 'finance-report',
      name: 'FinanceReport',
      component: () => import('@/views/report/financeReport/index.vue'),
      meta: {
        title: '财务报表',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['*'],
      },
    },
  ],
};

export default Report;
